import React, {useEffect, useState} from 'react';
import {DetailGrid, wdiCore} from '@/components/GridWidget';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiCardTitle} from '@/components/WdiControls';
import {Button, Space} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats} from '@/components/WdiBus/TableColumnRanderFormats';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {Enum} from '@/enums/system';
import {getSchemaColumns, toExcel} from '@/components/WdiControls/WdiExcel';
import {GridApi} from '@/services/gridapi';
import {FormSa} from "@/services/sales/sa";
import DataStore from "@/components/GridWidget/DataStore";
import {getFormUrlMapping} from "@/components/WdiBus/FormPage";

export type DetailForApplyProps = {
  data?: any,
};

// 拓展列
const initRowFieldConfigs = (record: any) => {
  return [
    "currentRowNumber", "productBuyIds", "productFreeIds", "currentPriceSellinAfter", "currentPriceLimitBelowRate",
    "currentGrossRate", "currentAmount", "formNo", "originalPriceSellinAfter", "originalPriceLimitBelowRate",
    "originalGrossRate", "originalAmount", "currentQuantityBuy", "currentQuantityFree", "originalQuantityBuy", "originalQuantityFree",
  ];
};

const showDispModal = (evt: any) => {
  if (evt && evt.target) {
    const record = JSON.parse(evt.target.getAttribute("data-record"));
    window.open(getFormUrlMapping(record.pageTypeId, record.formTypeId) + `?formId=${record.formId}&pageTypeId=${record.pageTypeId}&formTypeId=${record.formTypeId}`);
  }
};

export const HistoryReferencePanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [dataSource, setDataSource] = useState<any[]>([]);

  const {data} = props;

  useEffect(() => {
    GridApi.searchConfig({id: 'HistoryReferenceForPd', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None,
        showAggr: true,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.formNo.getDisplayFormater = (text: any, record: any, index: any) => {
        return (
          <a onClick={showDispModal} data-key={record.formId} data-record={JSON.stringify(record)}>
            {text}
          </a>
        )
      };
      settings.formSchema.allFields.currentRowNumber.width = 70;
      settings.formSchema.allFields.productBuyIds.width = 240;
      settings.formSchema.allFields.productFreeIds.width = 240;
      settings.formSchema.allFields.currentPriceSellinAfter.width = 170;
      settings.formSchema.allFields.currentPriceLimitBelowRate.width = 120;
      settings.formSchema.allFields.currentGrossRate.width = 100;
      settings.formSchema.allFields.currentQuantityBuy.width = 190;
      settings.formSchema.allFields.currentQuantityFree.width = 190;
      settings.formSchema.allFields.currentAmount.width = 100;
      settings.formSchema.allFields.currentAmount.aggr = TableColumnRanderFormats.sumAggr('currentAmount', 2);
      settings.formSchema.allFields.formNo.width = 160;
      settings.formSchema.allFields.originalPriceSellinAfter.width = 200;
      settings.formSchema.allFields.originalPriceLimitBelowRate.width = 150;
      settings.formSchema.allFields.originalGrossRate.width = 120;
      settings.formSchema.allFields.originalQuantityBuy.width = 210;
      settings.formSchema.allFields.originalQuantityFree.width = 210;
      settings.formSchema.allFields.originalAmount.width = 120;
      settings.formSchema.allFields.originalAmount.aggr = TableColumnRanderFormats.sumAggr('originalAmount', 2);

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (data.formSaId) {
      FormSa.getReferenceHistoryVosForPd(data.formSaId).then(response => {
        setDataSource(DataStore.init(response.data));
      });
    }
  }, [data]);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initRowFieldConfigs(record);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    }
  };

  const exportDetails = () => {
    getSchemaColumns('HistoryReferenceForPd').then(columns => {
      const sheet = {
        data: dataSource,
        names: columns,
        sheetName: '历史随货活动参考',
      };
      toExcel({
        name: data?.formNo + '_历史随货活动参考_' + wdiCore.Date.ToString(new Date()) + '.xlsx',
        sheetProps: [sheet],
      });
    });
  };

  return (
    <WdiPanel
      title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='历史随货活动参考'/>} collapsed={true}
      extra={
        <Space>
          <Button type='primary' onClick={(e) => {
            exportDetails();
          }}>
            导出
          </Button>
        </Space>
      }>
      {isLoaded && (
        <DetailGrid {...pageGridSettings} />
      )}
    </WdiPanel>
  );
};
